export default __webpack_public_path__ + "static/media/iveco.7985f421.jpg";